import { PROVINCE_STATE_VALUE_TO_LABEL_MAP } from "../../../../../../constants";

export function getRegionByCode(code: string): string {
  return PROVINCE_STATE_VALUE_TO_LABEL_MAP[code] || "";
}
